import { createSession } from '../utils/jbSession';

export async function requestCulture() {
	return new Promise( (resolve) => { 
		const connection = createSession();

		connection.on('requestedCulture', async (locale) => {
			// console.log(`requestedCulture is ${locale}`);
			resolve(locale);
		});

		connection.trigger('requestCulture');
	});
}